import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, withInstagramIntegration } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink';
import FieldLabel from '../builder/FieldLabel';
import Tooltip from '../builder/Tooltip.js';
import { useOwner } from '../context/context.js';
import { ProfileModule } from '../ui_items/Module.js';

const IntegrationsStatus = (props) => {
	const owner = useOwner();
	const promotion = owner?.promotion?.Promotion ?? false;
	
	const hashtag_contest = promotion.promotion_type_id == 58;
	const promotion_with_ig = withInstagramIntegration(promotion.promotion_type_id);
	if(promotion === false || (!promotion_with_ig && !hashtag_contest)) return null;
	
	const integrations = props?.integrations ?? [];
	if(integrations.length == 0 && !hashtag_contest) return null;
	
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	let integrations_to_show = [];

	const instagram = integrations.find((o) => (o.type == 3));
	if(instagram) {
		integrations_to_show.push(instagram);
	} else if(promotion_with_ig || hashtag_contest) {
		integrations_to_show.push({
			name:i18n("Instagram"),
			status:0,
			status_case:'not_created',
			type:'3',
			type_name:'instagram',
		});
	}

	/*
	const twitter = integrations.find((o) => (o.type == 4));
	if(twitter) {
		integrations_to_show.push(twitter);
	} else if(promotion.promotion_type_id == promotion_type_id) {
		integrations_to_show.push({
			name:i18n("Twitter"),
			status:0,
			status_case:'not_created',
			type:'4',
			type_name:'twitter',
		});
	}*/

	return (
		<ProfileModule 
			title={{ label:"Instagram Mention + Hashtag Tracking", icon:'knk-life-status'}}
			subtitle="Automatically imports photos, videos and reels from public Instagram profiles."
		>
			<ul class="gui_clean_listed_elements gui_status_view keep_gap">
				{integrations_to_show.map((integration, i) => {
					const activated = (integration.status == 1) ? true : false;
					let monitoring_status  = activated;
					let monitoring_comment = null;
					let icon = 'knk-help-ui';

					switch(integration.status_case) {
						case 'not_created':
							monitoring_comment = props.intl.formatMessage({ id:"You must enable {label_social} integration" },{ label_social:integration.name });
							monitoring_status = false;
							break;

						case 'not_active':
							monitoring_comment = "The promotion is not active";
							monitoring_status = false;
							break;

						case 'pending_open':
							monitoring_comment = "New mentions will not be imported because the promotion is not yet open for entries";
							icon = 'knk-alert redIcon';
							break;

						case 'finished':
							monitoring_comment = "New mentions will not be imported because the promotion is already closed";
							monitoring_status = false;
							break;

						case 'open':
						case 'ok':
						default:
							break;
					}

					return (
						<li key={i} class={`in_bottom ${(monitoring_status) ? 'is_ok' : 'is_ko'}`}>
							
							<div>
								<span class="status">
									<FieldLabel
										_class={{other:'in_top in_bottom'}}
										autotranslate={false}
										tooltip={<Tooltip icon={icon} position='top'>{monitoring_comment}</Tooltip>}
									>
										<FormattedMessage id="{label} status monitor" values={{label:integration.name}} />
									</FieldLabel>

									<span class="gui_not_in_start">{i18n((monitoring_status) ? "Enabled" : "Disabled")}</span>
								</span>

								<ActionLink
									_class={{other:'gui_in_end'}}
									_href={`/integrations/${integration.type_name}/${promotion.id}`}
								>View</ActionLink>
							</div>
						</li>
					)
				})}
			</ul>
		</ProfileModule>
	);
}

export default injectIntl(IntegrationsStatus);